const GET_CHECKOUT_DETAILS = 'GET_CHECKOUT_DETAILS';
const GET_CHECKOUT_DETAILS_SUCCESS = 'GET_CHECKOUT_DETAILS_SUCCESS';
const GET_CHECKOUT_DETAILS_ERROR = 'GET_CHECKOUT_DETAILS_ERROR';
const GET_CHECKOUT_DETAILS_RESPONSE = 'GET_CHECKOUT_DETAILS_RESPONSE';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const CEF_CHECKOUT_DETAILS_ERROR = 'CEF_CHECKOUT_DETAILS_ERROR';
const RESET_GET_CHECKOUT_DETAILS = 'RESET_GET_CHECKOUT_DETAILS';
const PREFETCH_SHIPPING_STATUS = 'PREFETCH_SHIPPING_STATUS';
export const UPDATE_MOVERS_LINE_DATA = 'UPDATE_MOVERS_LINE_DATA';

export {
  GET_CHECKOUT_DETAILS,
  GET_CHECKOUT_DETAILS_SUCCESS,
  GET_CHECKOUT_DETAILS_ERROR,
  GET_CHECKOUT_DETAILS_RESPONSE,
  ASYNC_FETCH_SUCCESS,
  CEF_CHECKOUT_DETAILS_ERROR,
  RESET_GET_CHECKOUT_DETAILS,
  PREFETCH_SHIPPING_STATUS,
};
